// extracted by mini-css-extract-plugin
export default {"footerContainer":"style_footerContainer__J8KP1","copyrightNote":"style_copyrightNote__vGUGF"};